import { Link } from "react-router-dom";

export default function PageNotFound(params) {
  return (
    <>
      <h1>404 Page Not Found.</h1>
      <Link to="/drive/directory">Back to Home</Link>
    </>
  );
}
